import { motion } from "framer-motion";
import { STATEMENT, BRAND } from "../data/content";
import { SectionLabel, Reveal } from "./Reveal";

// Numbered manifesto chapters.
export default function Statement() {
  return (
    <section id="statement" className="relative w-full py-24 md:py-40 px-5 md:px-10" data-testid="section-statement">
      <div className="max-w-[1100px] mx-auto">
        <SectionLabel index="06 / STATEMENT" id="statement-label">MANIFESTO</SectionLabel>

        <div className="mt-4">
          {STATEMENT.chapters.map((c, i) => (
            <motion.div
              key={c.no}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-15% 0px" }}
              transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
              className="grid md:grid-cols-12 gap-4 md:gap-8 py-10 md:py-14 border-t border-white/10 items-start"
            >
              <div className="md:col-span-3 flex items-baseline gap-4">
                <span className="font-display steel-text text-5xl md:text-6xl leading-none">{c.no}</span>
                <span className="track-label text-white/40">{c.title}</span>
              </div>
              <p className="md:col-span-9 font-display text-2xl sm:text-3xl md:text-[2.6rem] leading-[1.15] text-white/85 tracking-tight">
                <Reveal text={c.body} />
              </p>
            </motion.div>
          ))}
        </div>

        <div className="border-t border-white/10 pt-10 mt-2 text-center">
          <p className="font-display chrome-text text-3xl md:text-5xl italic">{BRAND.phrase}</p>
        </div>
      </div>
    </section>
  );
}
